import { createSlice } from "@reduxjs/toolkit";

const savedState = JSON.parse(localStorage.getItem("outreach")) || {
  outreachSuppliers: {},
  bulkOutreach: {},
};

const initialState = {
  outreachSuppliers: savedState.outreachSuppliers || {},
  bulkOutreach: savedState.bulkOutreach || {},
};

const messagesSlice = createSlice({
  name: "messages",
  initialState,
  reducers: {
    sendMessage: (state, action) => {
      const { message, suppliers, subject, supplierId, supplier } =
        action.payload;

      const saveMessage = (target) => {
        if (!target.messages) target.messages = [];
        target.messages.push(message);
      };

      if (suppliers && suppliers.length && subject) {
        if (!state.bulkOutreach[subject]) {
          state.bulkOutreach[subject] = {
            subject,
            suppliers: {},
            timestamp: message.timestamp,
          };
        }

        suppliers.forEach(({ supplierId, supplier }) => {
          if (!state.bulkOutreach[subject].suppliers[supplierId]) {
            state.bulkOutreach[subject].suppliers[supplierId] = {
              supplier: supplier || {},
              messages: [],
            };
          }
          saveMessage(state.bulkOutreach[subject].suppliers[supplierId]);
        });
      } else if (subject && supplierId) {
        if (!state.bulkOutreach[subject]) {
          state.bulkOutreach[subject] = {
            subject,
            suppliers: {},
            timestamp: message.timestamp,
          };
        }
        if (!state.bulkOutreach[subject].suppliers[supplierId]) {
          state.bulkOutreach[subject].suppliers[supplierId] = {
            supplier: supplier || {},
            messages: [],
          };
        }
        saveMessage(state.bulkOutreach[subject].suppliers[supplierId]);
      } else if (supplierId) {
        if (!state.outreachSuppliers[supplierId]) {
          state.outreachSuppliers[supplierId] = {
            supplier: supplier || {},
            messages: [],
          };
        } else if (supplier) {
          state.outreachSuppliers[supplierId].supplier = supplier;
        }
        saveMessage(state.outreachSuppliers[supplierId]);
      }

      localStorage.setItem(
        "outreach",
        JSON.stringify({
          outreachSuppliers: state.outreachSuppliers,
          bulkOutreach: state.bulkOutreach,
        })
      );
    },

    receiveMessage: (state, action) => {
      const { supplierId, supplier, content, timestamp } = action.payload;

      if (!state.outreachSuppliers[supplierId]) {
        state.outreachSuppliers[supplierId] = {
          supplier,
          messages: [],
        };
      }

      state.outreachSuppliers[supplierId].messages.push({
        type: "received",
        content,
        timestamp,
      });

      localStorage.setItem(
        "outreach",
        JSON.stringify({
          outreachSuppliers: state.outreachSuppliers,
          bulkOutreach: state.bulkOutreach,
        })
      );
    },

    clearMessages: (state, action) => {
      const { supplierId } = action.payload;
      if (state.outreachSuppliers[supplierId]) {
        state.outreachSuppliers[supplierId].messages = [];
      }

      localStorage.setItem(
        "outreach",
        JSON.stringify({
          outreachSuppliers: state.outreachSuppliers,
          bulkOutreach: state.bulkOutreach,
        })
      );
    },
  },
});

export const { sendMessage, receiveMessage, clearMessages } =
  messagesSlice.actions;
export default messagesSlice.reducer;
